import React from 'react'

const FilterCard = ({ele,category,setcategory}) => {  
  return (
    <div className={`flex cursor-pointer text-2xl capitalize ${category===ele.title?`text-red border-b-1 border-red`:`text-white`}`} onClick={()=>{setcategory(ele.title)}}>
      {ele.title}
    </div>
  )
}

export default FilterCard
